import { Card, CardContent, Theme, Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/styles';
import React from 'react'
import { BackgroundType, getBackgroundTypeName } from '../../contexts/SettingsProvider';
import NotInterestedIcon from '@material-ui/icons/NotInterested'
import ScatterPlotIcon from '@material-ui/icons/ScatterPlot'
import AcUnitIcon from '@material-ui/icons/AcUnit'
import StarIcon from '@material-ui/icons/Star'
import EcoIcon from '@material-ui/icons/Eco'
import BubbleChartIcon from '@material-ui/icons/BubbleChart'
import LocationCityIcon from '@material-ui/icons/LocationCity'

interface IBackgroundItemProps {
    type: BackgroundType
    isSelected: boolean,
    onSelected: (type: BackgroundType) => void
}

export default function BackgroundItem({ type, isSelected, onSelected }: IBackgroundItemProps) {
    const theme = useTheme<Theme>()

    function handleClicked() {
        onSelected(type)
    }

    function getBgColor(): string {
        switch (type) {
            case BackgroundType.Snow: return "white"
            case BackgroundType.Connected: return theme.palette.primary.main
            case BackgroundType.Stars: return "#000000"
            case BackgroundType.FallLeaves: return "#E09119"
            case BackgroundType.Bubbles: return "#2a6fdb"
            case BackgroundType.City: return "#1a2744"
            default: return "black"
        }
    }

    function getTextColor(): string {
        switch (type) {
            case BackgroundType.Snow: return "#483D8B"
            case BackgroundType.Connected: return theme.palette.text.primary
            case BackgroundType.Stars: return "#ffffff"
            case BackgroundType.FallLeaves: return "#000000"
            case BackgroundType.Bubbles: return "#ffffff"
            case BackgroundType.City: return "#e8eef8"
            default: return "white"
        }
    }

    function getIcon() {
        switch (type) {
            case BackgroundType.None: return <NotInterestedIcon fontSize="small" />
            case BackgroundType.Connected: return <ScatterPlotIcon fontSize="small" />
            case BackgroundType.Snow: return <AcUnitIcon fontSize="small" />
            case BackgroundType.Stars: return <StarIcon fontSize="small" />
            case BackgroundType.FallLeaves: return <EcoIcon fontSize="small" />
            case BackgroundType.Bubbles: return <BubbleChartIcon fontSize="small" />
            case BackgroundType.City: return <LocationCityIcon fontSize="small" />
            default: return <NotInterestedIcon fontSize="small" />
        }
    }

    const color = getTextColor()

    return (
        <Card
            onClick={handleClicked}
            style={{
                width: '100%',
                cursor: 'pointer',
                backgroundColor: getBgColor(),
                color,
                boxShadow: isSelected ? `0 0 0 2px ${theme.palette.primary.main}` : undefined,
            }}
        >
            <CardContent style={{ padding: 12, display: 'flex', alignItems: 'center' }}>
                <span style={{ display: 'inline-flex', marginRight: 8, color }}>
                    {getIcon()}
                </span>
                <Typography variant="body2" style={{ color }}>
                    {getBackgroundTypeName(type)}
                </Typography>
            </CardContent>
        </Card>
    )
}
